import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { handleLeftSideBar } from "../../redux/app/actions";
import ModalWrapper from "../../containers/ModalWrapper";

import UserIcon from "../../assets/images/icons/user-icon.webp";
import WithdrawIcon from "../../assets/images/icons/leftbar/new/withdrawl.webp";
import Mybetsicon from "../../assets/images/icons/leftbar/new/money.webp";
import eferralicon from "../../assets/images/icons/leftbar/new/network.webp";
import bonusiccon from "../../assets/images/icons/leftbar/new/present.webp";
import ACIcon from "../../assets/images/icons/leftbar/new/online-betting.webp";
import deposithistoricon from "../../assets/images/icons/leftbar/new/financial-statements.webp";
import withdrawhistoryicon from "../../assets/images/icons/leftbar/new/withdrawl.webp";
import HomeIcon from "./../../assets/images/icons/leftbar/new/user.webp";
import logouticon from "../../assets/images/icons/leftbar/new/logout.webp";
import Ezugi from "../../assets/images/icons/leftbar/ezugi.webp";
import Evolution from "../../assets/images/icons/leftbar/ezugi.webp";
import Supernowa from "../../assets/images/icons/leftbar/supernowa.webp";
import Vivo from "../../assets/images/icons/leftbar/vivo.webp";
import XPG from "../../assets/images/icons/leftbar/xpg.webp";
import Worldcasino from "../../assets/images/icons/leftbar/worldcasino.webp";
import Qtech from "../../assets/images/icons/leftbar/qtech.webp";
import ThemeSelector from "./ThemeSelector";
import { Dropdown } from "react-bootstrap";

import ArrowDown from "../../assets/images/icons/arrow-down.webp";
import numberWithCommas from "../../utils/numbersWithComma";
import DepositIcon from "../../assets/images/icons/deposit-icon.webp";

import account_img from "../../assets/images/icons/leftbar/new/accountstatement-img.png";
import profile_img from "../../assets/images/icons/leftbar/new/profile-img.png";
import referral_img from "../../assets/images/icons/leftbar/new/referral-img.png";
import deposit_img from "../../assets/images/icons/leftbar/new/deposit-img.png";

import { logoutUser } from "../../redux/auth/actions";

const LeftBarSports = () => {
  const { user } = useSelector((state) => state.auth);
  const { isAuth } = useSelector((state) => state.auth);
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");
  const { showLeftSideBar } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const location = useLocation();
  const [activePage] = useState("");
  const { wallet } = useSelector((state) => state.auth);

  const providers = [
    {
      name: "Evolution",
      path: "/casino/evolution",
      isIcon: true,
      icon: Evolution,
    },
    { name: "Ezugi", path: "/casino/ezugi", isIcon: true, icon: Ezugi },
    {
      name: "Supernowa",
      path: "/casino/supernowa",
      isIcon: true,
      icon: Supernowa,
    },
    { name: "Vivo", path: "/casino/vivo", isIcon: true, icon: Vivo },
    { name: "XPG", path: "/casino/xpg", isIcon: true, icon: XPG },
    {
      name: "Worldcasino",
      path: "/casino/worldcasino",
      isIcon: true,
      icon: Worldcasino,
    },
    { name: "Qtech", path: "/casino/qtech", isIcon: true, icon: Qtech },
  ];

  return (
    <>
      <aside className="side-menu">
        <div className="leftbarSec">
          {/* <div className="close-bar">
            <a
              href="#"
              className="close-btn"
              onClick={() => dispatch(handleLeftSideBar(!showLeftSideBar))}
            >
              <img src={CloseIcon} alt="close" />
            </a>
          </div> */}

          {!isAuth && (
            <div className="user bfr-lgn">
              <div className="user-login">
                {/* <div className="img-box">
                  <img src={UserIcon} alt="user" />
                </div> */}
              </div>
            </div>
          )}

          {isAuth && (
            <>
              <div className="user aftr-lgn">
                <div className="user-img">
                  <img src={UserIcon} alt="user" />
                </div>

                <div className="user-name">
                  <h5>{user?.userName}</h5>
                  <h6>{user?.mobileNumber}</h6>
                </div>
              </div>

              <div className="BalaceSection">
                <div className="bal-dpst">
                  <div className="balance">
                    <span>
                      <strong>{wallet?.balance}&nbsp;</strong>
                      <Dropdown align="center" className="balanceDropdown">
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-balance"
                        >
                          {/* <img src={ArrowDown} alt="balance" /> */}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <div className="bal real">
                            <p>Main Wallet</p>
                            <div className="box">
                              {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                              <div className="amnt">
                                {numberWithCommas(wallet?.balance)}
                              </div>
                              {/* <div className="dpst">
                                <a href="/gatewaylist">
                                  <img src={DepositIcon} alt="deposit" />
                                </a>
                              </div> */}
                            </div>
                          </div>
                          <div className="bal cash">
                            <p>Cash</p>
                            <div className="box">
                              {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                              <div className="amnt">
                                {numberWithCommas(wallet?.cash)}
                              </div>
                            </div>
                          </div>
                          <div className="bal bonus">
                            <p>Bonus</p>
                            <div className="box">
                              {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                              <div className="amnt">
                                {numberWithCommas(wallet?.coins)}
                              </div>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </span>
                  </div>
                  {/* <DepositModal /> */}
                  <div className="dpst-btn">
                    <a href="/gatewaylist" className="btn">
                      Deposit
                    </a>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="menu-link">
            <ul>
              <li className="imgSection">
                <a href="/profile">
                  <img src={HomeIcon} alt="home" />
                  <span>My Profile</span>
                </a>
                <img src={profile_img} alt="aviator" className="ImgPresent" />
              </li>
              <li>
                <a href="/withdraw">
                  <img src={WithdrawIcon} alt="Sports" />
                  <span>Withdrawal</span>
                </a>
              </li>
              <li className="imgSection">
                <a href="/depsoit/list">
                  <img src={deposithistoricon} alt="aviator" />
                  <span>Deposit History</span>
                </a>
                <img src={deposit_img} alt="aviator" className="ImgPresent" />
              </li>
              <li>
                <a href="/withdraw/list">
                  <img src={withdrawhistoryicon} alt="aviator" />
                  <span>Withdraw History</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={Mybetsicon} alt="exchange" />
                  <span>Bets History</span>
                </a>
              </li>
              <li className="imgSection">
                <a href="/referral">
                  <img src={eferralicon} alt="Casino" />
                  <span>Referral</span>
                </a>
                <img src={referral_img} alt="aviator" className="ImgPresent" />
              </li>
              <li>
                <a href="/bonus">
                  <img src={bonusiccon} alt="live casino" />
                  <span>Bonus</span>
                </a>
              </li>

              <li className="imgSection">
                <a href="cashier">
                  <img src={ACIcon} alt="aviator" />
                  <span>Statement</span>
                </a>
                <img src={account_img} alt="aviator" className="ImgPresent" />
              </li>

              <li href="#" onClick={() => dispatch(logoutUser())}>
                <a>
                  <img src={logouticon} alt="aviator" />
                  <span>Log Out</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="MobThemeBtn">
            <ThemeSelector />
          </div>
        </div>
      </aside>

      {showAuthModals && (
        <ModalWrapper
          defaultShow={defaultModal}
          handleClose={setShowAuthModals}
        />
      )}
    </>
  );
};

export default LeftBarSports;
